import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import {ContractEditIcon} from "assets/icons";

const ContractLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Contrats"} 
            routeSidebar={"/contract/toBeSigned"}
            icon={ContractEditIcon}
            text={"Contrats"}
        />
    );
};

export default ContractLink;

